
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'data-privacy-request-ui',
  currentProjectVersion: 'static-1.5435',
  depVersions: {
  "data-privacy-request-ui": "static-1.5435",
  "data-fetching-client": "static-1.9582",
  "head-dlb": "static-1.4938",
  "history": "static-4.47",
  "hs-test-utils": "static-1.7920",
  "hub-http-shared-msw-handlers": "static-1.9746",
  "hubspot-dlb": "static-2.1832",
  "HubStyleTokens": "static-2.11364",
  "I18n": "static-7.1604",
  "jasmine-runner": "static-1.6375",
  "privacy-center-public-service-types": "static-1.4698",
  "quartz": "static-1.6880",
  "react-dlb": "static-1.77",
  "react-router-dom": "static-5.26",
  "ui-components-test-utils": "static-1.5502",
  "UIComponents": "static-3.8311",
  "webpack-env": "static-1.54",
  "apollo-stack-hubspot": "static-3.84",
  "foundations-assets": "static-1.4757",
  "foundations-components": "static-1.7739",
  "foundations-components-test-utils": "static-1.5222",
  "foundations-theming": "static-1.4321",
  "hub-http": "static-1.6126",
  "quartz-config": "static-1.658",
  "quartz-core": "static-1.6099",
  "quartz-routing": "static-1.310",
  "quick-fetch": "static-1.3841",
  "raven": "static-3.5829",
  "react": "static-7.184",
  "react-rhumb": "static-1.16565",
  "SharedI18nStrings": "static-1.182",
  "ui-addon-i18n": "static-1.11056",
  "usage-tracker": "static-1.7244",
  "usage-tracker-anonymous": "static-1.5661",
  "usage-tracker-core": "static-1.7094",
  "enviro": "static-4.428",
  "hs-promise-rejection-tracking": "static-1.5489",
  "PortalIdParser": "static-2.388",
  "raven-hubspot": "static-1.6136",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4049",
  "immutable": "static-2.77",
  "metrics-js": "static-1.9542",
  "react-redux": "static-7.70",
  "redux": "static-4.16",
  "styled-components": "static-2.88",
  "bend-plugin-trellis-migration": "static-1.3332",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3157",
  "quartz-webpack": "static-1.3104",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.80",
  "HeadJS": "static-2.736",
  "framer-motion": "static-1.70",
  "hs-test-utils-bend-plugin": "static-1.3031",
  "msw": "static-1.39",
  "testing-library": "static-1.150",
  "ts-schema": "static-1.4003",
  "i18n-data": "static-1.219",
  "moment-timezone": "static-5.81",
  "react-utils": "static-2.5273",
  "StyleGuideUI": "static-3.485",
  "jasmine": "static-4.4231",
  "rpc-client-utils": "static-1.4551",
  "HubStyle": "static-2.11672",
  "ui-addon-draggable": "static-3.4677",
  "cssUtils": "static-1.771",
  "hs-story-utils": "static-1.9337",
  "icons": "static-2.639",
  "react-select-plus": "static-1.65",
  "react-virtualized": "static-2.97",
  "ui-images": "static-2.1131",
  "bend-plugin-foundations-components": "static-1.4008",
  "floating-ui": "static-1.54",
  "foundations-theming-specialty": "static-1.2037",
  "react-aria": "static-1.64",
  "tanstack-table": "static-1.53",
  "trellis-assets": "static-1.1553",
  "ui-fonts": "static-1.626",
  "foundations-components-legacy": "static-1.764",
  "bend-plugin-foundations-theming": "static-1.2804",
  "foundations-theming-base": "static-1.3306",
  "stylex": "static-1.30",
  "dispatcher": "static-1.134",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.820",
  "hubspotter-http": "static-1.4577",
  "mobile-manifest-mixins": "static-1.509",
  "module-federation": "static-1.21",
  "quartz-auth": "static-1.555",
  "quartz-head": "static-1.545",
  "quartz-i18n": "static-1.555",
  "quartz-test": "static-1.555",
  "quartz-tracking": "static-1.259",
  "usage-tracker-container": "static-1.7234",
  "csstype": "static-1.50",
  "react-input-autosize": "static-2.17",
  "bender-build-tools": "static-1.3063",
  "chirp-fetch": "static-1.1788",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-flip-move": "static-1.68",
  "sassPrefix": "static-1.154",
  "hubspotter-http-shared-msw-handlers": "static-1.9744",
  "usage-tracker-session-replay": "static-1.4930",
  "amplitude-session-replay-browser": "static-1.58"
},
  depPathPrefixes: {
  "data-privacy-request-ui": "/data-privacy-request-ui/static-1.5435",
  "data-fetching-client": "/data-fetching-client/static-1.9582",
  "head-dlb": "/head-dlb/static-1.4938",
  "history": "/history/static-4.47",
  "hs-test-utils": "/hs-test-utils/static-1.7920",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9746",
  "hubspot-dlb": "/hubspot-dlb/static-2.1832",
  "HubStyleTokens": "/HubStyleTokens/static-2.11364",
  "I18n": "/I18n/static-7.1604",
  "jasmine-runner": "/jasmine-runner/static-1.6375",
  "privacy-center-public-service-types": "/privacy-center-public-service-types/static-1.4698",
  "quartz": "/quartz/static-1.6880",
  "react-dlb": "/react-dlb/static-1.77",
  "react-router-dom": "/react-router-dom/static-5.26",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5502",
  "UIComponents": "/UIComponents/static-3.8311",
  "webpack-env": "/webpack-env/static-1.54",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "foundations-assets": "/foundations-assets/static-1.4757",
  "foundations-components": "/foundations-components/static-1.7739",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5222",
  "foundations-theming": "/foundations-theming/static-1.4321",
  "hub-http": "/hub-http/static-1.6126",
  "quartz-config": "/quartz-config/static-1.658",
  "quartz-core": "/quartz-core/static-1.6099",
  "quartz-routing": "/quartz-routing/static-1.310",
  "quick-fetch": "/quick-fetch/static-1.3841",
  "raven": "/raven/static-3.5829",
  "react": "/react/static-7.184",
  "react-rhumb": "/react-rhumb/static-1.16565",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11056",
  "usage-tracker": "/usage-tracker/static-1.7244",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5661",
  "usage-tracker-core": "/usage-tracker-core/static-1.7094",
  "enviro": "/enviro/static-4.428",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5489",
  "PortalIdParser": "/PortalIdParser/static-2.388",
  "raven-hubspot": "/raven-hubspot/static-1.6136",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4049",
  "immutable": "/immutable/static-2.77",
  "metrics-js": "/metrics-js/static-1.9542",
  "react-redux": "/react-redux/static-7.70",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.88",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3332",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3157",
  "quartz-webpack": "/quartz-webpack/static-1.3104",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.80",
  "HeadJS": "/HeadJS/static-2.736",
  "framer-motion": "/framer-motion/static-1.70",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3031",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.150",
  "ts-schema": "/ts-schema/static-1.4003",
  "i18n-data": "/i18n-data/static-1.219",
  "moment-timezone": "/moment-timezone/static-5.81",
  "react-utils": "/react-utils/static-2.5273",
  "StyleGuideUI": "/StyleGuideUI/static-3.485",
  "jasmine": "/jasmine/static-4.4231",
  "rpc-client-utils": "/rpc-client-utils/static-1.4551",
  "HubStyle": "/HubStyle/static-2.11672",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4677",
  "cssUtils": "/cssUtils/static-1.771",
  "hs-story-utils": "/hs-story-utils/static-1.9337",
  "icons": "/icons/static-2.639",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-virtualized": "/react-virtualized/static-2.97",
  "ui-images": "/ui-images/static-2.1131",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4008",
  "floating-ui": "/floating-ui/static-1.54",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2037",
  "react-aria": "/react-aria/static-1.64",
  "tanstack-table": "/tanstack-table/static-1.53",
  "trellis-assets": "/trellis-assets/static-1.1553",
  "ui-fonts": "/ui-fonts/static-1.626",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.764",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2804",
  "foundations-theming-base": "/foundations-theming-base/static-1.3306",
  "stylex": "/stylex/static-1.30",
  "dispatcher": "/dispatcher/static-1.134",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.820",
  "hubspotter-http": "/hubspotter-http/static-1.4577",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.509",
  "module-federation": "/module-federation/static-1.21",
  "quartz-auth": "/quartz-auth/static-1.555",
  "quartz-head": "/quartz-head/static-1.545",
  "quartz-i18n": "/quartz-i18n/static-1.555",
  "quartz-test": "/quartz-test/static-1.555",
  "quartz-tracking": "/quartz-tracking/static-1.259",
  "usage-tracker-container": "/usage-tracker-container/static-1.7234",
  "csstype": "/csstype/static-1.50",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "bender-build-tools": "/bender-build-tools/static-1.3063",
  "chirp-fetch": "/chirp-fetch/static-1.1788",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-flip-move": "/react-flip-move/static-1.68",
  "sassPrefix": "/sassPrefix/static-1.154",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9744",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4930",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.58"
}
};
